import { addParams, removeParams } from './query';

type HydratedOptions = {
  match: { params: { [key: string]: string } };
  keepForce: boolean;
  removeParams: string[];
};

const toWithSearch = (path: string, location: Location, options = {}) => {
  const hydratedOptions: HydratedOptions = {
    match: { params: {} },
    keepForce: false,
    removeParams: [],
    ...options
  };
  const { search } = location;
  if (hydratedOptions.match && hydratedOptions.match.params) {
    Object.entries<string>(hydratedOptions.match.params).forEach(
      ([key, entry]: [string, string]) => {
        path = path.replace(`:${key}`, entry);
      }
    );
  }
  if (!hydratedOptions.keepForce) {
    hydratedOptions.removeParams.push('force');
  }
  const filteredSearch = removeParams(search, hydratedOptions.removeParams);
  return path + filteredSearch;
};

const vehicleParams = ['year', 'make', 'model', 'trim', 'vin', 'licensePlate', 'plateState'];

const buildNavigationUrl = (
  baseUrl: string,
  paramsToAdd: { [key: string]: string } = {},
  paramsToRemove: string[] = [],
  initialSearch?: string
): string => {
  const search = initialSearch || (window?.location?.search ?? '');
  const allParamsToRemove = [...paramsToRemove, ...vehicleParams];
  const allParamsToAdd = { ...paramsToAdd };
  const filteredSearch = removeParams(search, allParamsToRemove);
  const hydratedSearch = addParams(filteredSearch, allParamsToAdd);
  return `${baseUrl}${hydratedSearch}`;
};

export { toWithSearch, buildNavigationUrl };
